import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useRef, useEffect } from 'react';
import { Plus, ChevronDown, ChevronRight, FileText, Users, Building } from 'lucide-react';
const TEMPLATE_GROUPS = [
    {
        id: 'company',
        name: 'Phoenix Corp',
        icon: Building,
        templates: [
            { id: 'comp-obj', name: 'Objective', type: 'objective', icon: FileText },
            { id: 'comp-kr1', name: 'Key result', type: 'key_result', icon: FileText },
            { id: 'comp-kr2', name: 'Key result', type: 'key_result', icon: FileText },
            { id: 'comp-ind', name: 'Individual goal', type: 'individual_goal', icon: FileText },
        ]
    },
    {
        id: 'marketing',
        name: 'Marketing ANZ',
        icon: Users,
        templates: [
            { id: 'mkt-obj', name: 'Objective', type: 'objective', icon: FileText },
            { id: 'mkt-kr', name: 'Key result', type: 'key_result', icon: FileText },
        ]
    }
];
export function AddGoalDropdown({ onCreateBlankGoal, onCreateFromTemplate }) {
    const [isOpen, setIsOpen] = useState(false);
    const [expandedGroups, setExpandedGroups] = useState(new Set());
    const dropdownRef = useRef(null);
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
        if (isOpen) {
            document.addEventListener('mousedown', handleClickOutside);
        }
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isOpen]);
    const toggleGroup = (groupId) => {
        setExpandedGroups(prev => {
            const newSet = new Set(prev);
            if (newSet.has(groupId)) {
                newSet.delete(groupId);
            }
            else {
                newSet.add(groupId);
            }
            return newSet;
        });
    };
    const handleTemplateClick = (template) => {
        onCreateFromTemplate(template);
        setIsOpen(false);
    };
    const handleBlankGoalClick = () => {
        onCreateBlankGoal();
        setIsOpen(false);
    };
    return (_jsxs("div", { className: "relative", ref: dropdownRef, children: [_jsxs("button", { onClick: () => setIsOpen(!isOpen), className: "flex items-center gap-2 px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white text-sm font-medium rounded-lg transition-colors", children: [_jsx(Plus, { className: "w-4 h-4" }), "Add goal", _jsx(ChevronDown, { className: `w-4 h-4 transition-transform ${isOpen ? 'rotate-180' : ''}` })] }), isOpen && (_jsxs("div", { className: "absolute left-0 top-full mt-2 w-72 bg-white dark:bg-gray-800 rounded-lg shadow-lg border border-gray-200 dark:border-gray-700 z-50 overflow-hidden", children: [_jsx("button", { onClick: handleBlankGoalClick, className: "w-full px-4 py-3 text-left text-sm text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700 border-b border-gray-200 dark:border-gray-700 transition-colors", children: "Blank goal" }), _jsxs("div", { className: "py-2", children: [_jsx("div", { className: "px-4 py-2 text-xs font-medium text-gray-500 dark:text-gray-400 uppercase", children: "Goal templates" }), TEMPLATE_GROUPS.map((group) => {
                                const isExpanded = expandedGroups.has(group.id);
                                const GroupIcon = group.icon;
                                return (_jsxs("div", { children: [_jsxs("button", { onClick: () => toggleGroup(group.id), className: "w-full px-4 py-2 flex items-center justify-between text-sm text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors", children: [_jsxs("div", { className: "flex items-center gap-2", children: [_jsx(GroupIcon, { className: "w-4 h-4 text-gray-500 dark:text-gray-400" }), _jsx("span", { children: group.name })] }), _jsx(ChevronRight, { className: `w-4 h-4 text-gray-400 transition-transform ${isExpanded ? 'rotate-90' : ''}` })] }), isExpanded && (_jsx("div", { className: "bg-gray-50 dark:bg-gray-900", children: group.templates.map((template) => {
                                                const TemplateIcon = template.icon;
                                                return (_jsxs("button", { onClick: () => handleTemplateClick(template), className: "w-full px-4 py-2 pl-12 flex items-center gap-2 text-sm text-gray-600 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors", children: [_jsx(TemplateIcon, { className: "w-3.5 h-3.5" }), _jsx("span", { children: template.name })] }, template.id));
                                            }) }))] }, group.id));
                            })] })] }))] }));
}
